<!--Main Navigation-->
<header class="intro-header">
    <!-- Intro Section -->
    <div class="background-image view jarallax" data-jarallax='{"speed": 0.2}'
        style="background-image: url(assets/images/wallpaperJourney.jpg)">
        <div class="full-bg-img mask rgba-black-light">
            <div class="container flex-center">
                <div class="row pt-5 mt-3 w-100">
                    <div class="col-md-12">
                        <div class="text-center">
                            <div class="avatar mx-auto flex-center border border-white"><img
                                    src="assets/images/profile-image.jpg" alt="avatar mx-auto white"
                                    class="rounded-circle img-fluid z-depth-5">
                            </div>
                            <h2 class="h1 h1-reponsive white-text font-up font-bold mb-3 wow fadeInDown"
                                data-wow-delay="0.3s"><strong>Sophie Raudrant</strong></h2>
                            <h5 class="white-text" style="font-size: smaller;">(SoPlump)</h5>
                            <hr class="hr-light mt-4 wow fadeInDown" data-wow-delay="0.4s">
                            <h5 class="font-up mb-5 white-text wow fadeInDown" data-wow-delay="0.4s"
                                style="line-height:1.5em;"><strong>Programmeuse de jeux
                                    vidéo<br>&<br> Ingénieure en informatique (étudiante) <br>passionnée<br> </strong>
                            </h5>
                            <div style="font-size:40px;color:white;">
                                <a class="icon-header" href="https://gitlab.com/SoPlump">
                                    <i class="fab fa-gitlab" style="padding: 10px;"></i></a>
                                <a class="icon-header" href="https://www.linkedin.com/in/sophie-raudrant-410658151/"><i
                                        class="fab fa-linkedin" style="padding: 10px;"></i></a>
                                <!-- <a class="icon-header" href="https://www.linkedin.com/in/sophie-raudrant-410658151/"><i
                                        class="fab fa-itch-io" style="padding: 10px;"></i></a> -->
                            </div>


                            <!-- <a mdbBtn color="white" outline="true" class="wow fadeInDown waves-light"
                                data-wow-delay="0.4s" mdbWavesEffect>portfolio</a>
                            <a mdbBtn color="white" outline="true" class="wow fadeInDown waves-light"
                                data-wow-delay="0.4s" mdbWavesEffect>About me</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>

<!--Main Navigation-->
<main>
    <div class="about">
        <app-about></app-about>
    </div>

    <div class="projects">
        <app-projects></app-projects>
    </div>
</main>